// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RancOz9oQd4tbtzyh48V{display:flex;flex-direction:row;justify-content:flex-start;padding:10px 15px}._iYLoOcG0u0ri_9jQCvA{justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageContainer": `RancOz9oQd4tbtzyh48V`,
	"messageContainerCentered": `_iYLoOcG0u0ri_9jQCvA`
};
export default ___CSS_LOADER_EXPORT___;
